import React from 'react';

import { Typography, Box } from '@mui/material';

export const Disclaimer = () => {
  return (
    <Box sx={{ m: 1 }}>
      <Typography variant="h5" sx={{ lineHeight: 1.4 }}>
        Disclaimer
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        This CoinOwl website available at https://coinowl.io (the “Site”) and all content have been
        prepared for informational and/or educational purposes only without regard to any particular
        user’s investment objectives, financial situation or means. Neither we, nor any of our
        affiliates, officers, directors, employees, agents or licensors are soliciting any action
        based on information made available on this Site. Reliance upon any content contained on or
        accessed in this Site is at your own risk.
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        The content on this Site is not to be construed as a recommendation or offer to buy or sell
        or the solicitation of an offer to buy or sell any cryptocurrency, financial product or
        instrument, or to participate in any particular trading strategy. We do not make any
        recommendations regarding the merit of any company, project, cryptocurrency or other
        financial product or instrument identified on this Site, nor do we make any recommendation
        regarding the purchase or sale of any such cryptocurrency, financial product or instrument
        that may be described or referred to on this Site, nor endorse or sponsor any company or
        project identified on this Site.
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        Prior to the making of any financial or investment decision, you are advised to consult with
        your banker, financial advisor or other relevant professionals (e.g. legal, tax and/or
        accounting counsel). We shall not be liable for any investment decisions based upon or
        results obtained from the content provided on this Site. Nothing contained on this Site is
        intended to be, nor shall it be construed to be, legal, tax, accounting or investment
        advice.
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        This Site is not directed at or intended for publication or distribution to any person in
        any jurisdiction where doing so would result in contravention of any applicable laws or
        regulations. It is the responsibility of the individual user to consider his or her legal
        and regulatory position in the relevant jurisdiction, the risks associated with trading such
        cryptocurrency, financial product or instrument and to ensure that the use of the content of
        this Site and the subsequent making of any decisions or taking any actions does not
        contravene any such restrictions or applicable laws and regulations of any jurisdiction.
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        Potential users of products or instruments described on this Site should familiarize
        themselves with the full contract specification of the cryptocurrency, financial product or
        instrument concerned and any associated information, such as any applicable legal or
        regulatory provisions. Please seek the advice of professionals, as appropriate, regarding
        the evaluation of any specific cryptocurrency, financial product, instrument, index, report,
        opinion, advice or other content.
      </Typography>
      <Typography variant="body2" sx={{ mt: 2 }}>
        YOU ALONE ASSUME SOLE RESPONSIBILITY FOR ANY DECISIONS YOU MAKE BASED ON THE INFORMATION
        AND/OR THE USE OF THE SITE. ALL INFORMATION IS PROVIDED “AS IS“ WITHOUT WARRANTY OF ANY
        KIND. WE MAKE NO REPRESENTATIONS AND DISCLAIM ALL EXPRESS, IMPLIED, AND STATUTORY WARRANTIES
        OF ANY KIND TO USER AND/OR ANY THIRD PARTY, INCLUDING WARRANTIES AS TO ACCURACY, TIMELINESS,
        COMPLETENESS, MERCHANTABILITY, OR FITNESS FOR ANY PARTICULAR PURPOSE. UNDER NO CIRCUMSTANCES
        SHALL WE BE LIABLE FOR ANY LOSS OR DAMAGE YOU OR ANYONE ELSE INCURS AS A RESULT OF ANY
        ACTIVITY THAT YOU OR ANYONE ELSE ENGAGES IN BASED ON ANY INFORMATION YOU RECEIVE THROUGH THE
        SITE OR AS A RESULT OF THE USE OF THE SITE.
      </Typography>
    </Box>
  );
};
